import React from 'react'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import CableIcon from '@mui/icons-material/Wallet'

const ConnectMyAccounts = ({ onConnect }) => {
    return (
        <div className="connect-my-accounts">
            <Button onClick={onConnect}>
                Connect My Accounts &nbsp;<CableIcon />
            </Button>
        </div>
    )
}

ConnectMyAccounts.propTypes = {
    onConnect: PropTypes.func,
}

ConnectMyAccounts.defaultProps = {
    onConnect: () => {},
}

export default ConnectMyAccounts
